import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/HomePage.vue"),
  },
  {
    path: "/privacypolicy",
    name: "privacypolicy",
    component: () => import("@/views/PrivacyPolicy.vue"),
  },
  {
    path: "/account-deletion",
    name: "account-deletion",
    component: () => import("@/views/AccountDeletion.vue"),
  },
  {
    path: "/child-safety",
    name: "child-safety",
    component: () => import("@/views/ChildSafety.vue"),
  },
  {
    path: "/get-app",
    name: "get-app",
    component: () => import("@/views/GetApp.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
